import { render } from "./ChatDetails.vue?vue&type=template&id=ed7b1876&scoped=true&ts=true"
import script from "./ChatDetails.vue?vue&type=script&lang=ts"
export * from "./ChatDetails.vue?vue&type=script&lang=ts"

import "./ChatDetails.vue?vue&type=style&index=0&id=ed7b1876&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7b1876"]])

export default __exports__